import { Icon } from 'components/Icon/IconDeprecated';

type ChartErrorProps = { error?: string };

/** Error message for chart components */
export function ChartError({
  error = 'Failed to fetch values.',
}: ChartErrorProps) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-2">
      <Icon name="error" className="theme danger" size="large" />
      <p>{error}</p>
    </div>
  );
}
